import { getKeys } from '../utils';

const isEmpty = (item) => item && getKeys(item).length > 0;
export const getAllowedNavigationItems = (
  navItems,
  allowedActions,
  isArray
) => {
  const filterNavItems = navItems
    ?.filter(
      (i) => (i.action && allowedActions?.includes(i.action)) || !i.action
    )
    .map((item) => {
      const { children } = item || {};

      const filteredChildren = children
        ?.map((child) => {
          if (child.type === 'collapse') {
            return getAllowedNavigationItems([child], allowedActions, true);
          }
          return !child.action || allowedActions?.includes(child.action)
            ? child
            : {};
        })
        .filter(isEmpty);

      return (
        ((filteredChildren && filteredChildren.length > 0) || item?.url) && {
          ...item,
          children: filteredChildren,
        }
      );
    })
    .filter(isEmpty);

  return isArray ? filterNavItems[0] : filterNavItems;
};
